import { EMPTY_VALUE } from '@src/core/config';
import { UnitType } from '@src/core/enums';
import { getUnitType } from '@src/core/features/settings/units';
import { arcToFixed } from "./arc-to-fixed";

export const arcSpatiumConvert = (value?: number | null | string) => {
  const payload = Number(value);
  const unitType = getUnitType();

  if (isNaN(payload)) return EMPTY_VALUE;

  if (unitType === UnitType.SI) return Number(arcToFixed(payload));

  if (unitType === UnitType.IMPERIAL) return Number(arcToFixed(payload * 3.28084));

  return EMPTY_VALUE;
};
